import React, {FC} from 'react';
import './style.scss';
import Header from "../Header";
import goBack from "../../assets/img/header/go__back.svg";
import {useHistory} from 'react-router-dom';

interface IPreferencesHeader {
    withoutBackButton?: boolean
}

const PreferencesHeader: FC<IPreferencesHeader> = ({withoutBackButton}) => {
    const history = useHistory();
    return (
        <Header>
            {
                withoutBackButton
                    ? (
                        <div className="preferences__header-container">
                            <span className="preferences__header-text">
                                Твои предпочтения
                            </span>
                        </div>
                    )
                    : (
                        <div className="standard__header">
                            <img
                                className="standard__header-img"
                                onClick={() => history.goBack()}
                                src={goBack}
                                alt="Go Back"
                            />
                            <div className="preferences__text-container">
                                 <span className="preferences__header-text">
                                    Твои предпочтения
                                 </span>
                            </div>
                        </div>
                    )
            }
        </Header>
    )
};

export default PreferencesHeader;
